export default __webpack_public_path__ + "static/media/cmd_nav_icon.9cb4740d.svg";